<template>
  <body id="body">
    <div id="header" class="header">
      <div class="logo">
        <img src="https://slotmatrix.com/wp-content/themes/slotmatrix/assets/img/logo.svg" class="w-32 xl:w-auto -translate-y-t-1" alt="logo">
      </div>
    </div>
    <div class="player-wrapper">
      <div id="player" class="player-section">
        <h2 class="replay-title" data-translation="game_round_replay">GAME ROUND REPLAY</h2>
        <tabs>
          <tab title="Armadillo Games">
            <game-replay-section :replayGameType="'Armadillo'"/>
          </tab>
          <tab title="Fantasma Games">
            <game-replay-section :replayGameType="'Fantasma'"/>
          </tab>
        </tabs>
      </div>
    </div>
  </body>
</template>

<script>
import GameReplaySection from '@/components/GameReplaySection.vue'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'

export default {
  name: 'ReplayPage',
  components: {
    GameReplaySection,
    Tab,
    Tabs
  }
}
</script>

<style>
  .logo {
    padding: 80px 40px 40px;
  }

  .replay-title {
    font-size: 3rem;
    line-height: 1;
    font-weight: bold;
  }

  .replay-label {
    font-size: 1.3rem;
    margin-bottom: .75rem;
  }

  .replay-field {
    padding: 10px;
  }

  .replay-value {
    height: 3.5rem;
    max-width: 26.6rem;
    width: 80%;
    border-radius: .5rem;
    border-width: 1px;
    border-color: rgb(255 255 255 / 0.2);
    background-color: rgb(123 58 142 / 0.1);
    padding-left: 1.25rem;
    padding-right: 1.25rem;
    font-size: 1rem;
    line-height: 1.5rem;
    color: rgb(255 255 255);
    outline: 2px solid transparent;
    outline-offset: 2px;
    -webkit-transition-duration: .3s;
    transition-duration: .3s;
  }

  .replay-actions {
    padding: 20px;
    margin-bottom: 50px;
    position: relative;
    display: flex;
    flex-direction: row;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.05);
    align-items: center;
    justify-content: center;

    .action {
      cursor: pointer;
      margin: 0 15px;
      border-radius: .5rem;
      background-color: rgb(255 255 255);
      padding: 0.5rem 0.5rem 0.3rem;
      color: rgb(123 58 142);
      -webkit-transition-duration: .3s;
      transition-duration: .3s;
      &:hover {
        background-color: rgb(123 58 142);
        color: rgb(255 255 255);
      }
      &:active {
        background-color: rgb(123 58 142);
        color: rgb(255 255 255);
      }
    }
    .disabled {
      color: #b7b7b7;
      &:hover {
        cursor: default;
        background-color: rgb(255 255 255);
        color: #b7b7b7;
      }
      &:active {
        cursor: default;
        background-color: rgb(255 255 255);
        color: #b7b7b7;
      }
    }
  }

  .error-section {
    padding: 10px;
    font-size: 1.4rem;
  }

  .game-frame {
    width: 100%;
    height: 100%;
    bottom: 40px;
    position: relative;
    border: 0;
  }

  .game-select {
    cursor: pointer;
    max-width: 29rem;
    width: 92%;
    margin: 20px auto;
    border-style: solid;
    border-radius: .5rem;
    border-width: 1px;
    border-color: rgb(255 255 255 / 0.2);
    background-color: rgb(123 58 142 / 0.1);
    .game-selector {
      height: 3.75rem;
      padding-left: 1.25rem;
      line-height: 1.5rem;
      color: rgb(255 255 255);
      outline: 2px solid transparent;
      outline-offset: 2px;
      -webkit-transition-duration: .3s;
      transition-duration: .3s;
      position: relative;
      z-index: 1;
      .arrow {
        position: absolute;
        right: 20px;
        top: 40%;
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-top: 10px solid #888;
        transform: rotateZ(0deg) translateY(0px);
        transition-duration: 0.3s;
        transition-timing-function: cubic-bezier(.59,1.39,.37,1.01);
      }
      .expanded {
        transform: rotateZ(180deg) translateY(2px);
      }
      .game-label {
        position: relative;
        display: flex;
        flex-direction: row;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding-right: 3rem;
        color: rgb(255 255 255);
      }
      .placeholder {
        color: #888;
      }
    }
    ul {
      width: 96.5%;
      right: 0;
      top: 3.7rem;
      list-style-type: none;
      padding: 1rem 0 1rem 1rem;
      margin: 0;
      font-size: 16px;
      border-radius: .5rem;
      border-width: 1px;
      border-color: rgb(255 255 255 / 0.2);
      background-color: #4e3756;
      position: absolute;
      z-index: 1;
    }
    li {
      width: 88%;
      padding: 0.3rem 1.3rem 0.3rem 1rem;
      &:hover {
        border-radius: .5rem;
        color: white;
        background-color: #604b67;
      }
    }
    .current {
      background: #eaeaea;
    }
    .hidden {
      visibility: hidden;
    }
    .visible {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ReplayPage.vue